import { UseMutationOptions } from '@tanstack/react-query';

import { CommonSuccess, GenericFailure } from '@playq/services-shared';
import { Environment } from '@playq/octopus-common';

import { useEitherMutation } from '/api/service-hooks';

import { IBeetleId } from './types';
import { methods } from './serviceHandlerRequest';
import { SupportContentType } from './types/supportContentType';

export const useUpdateNote = (
  type: SupportContentType,
  options?: UseMutationOptions<
    CommonSuccess,
    GenericFailure | Error,
    { id: IBeetleId; noteId: string; env: Environment; note: string }
  >
) => {
  const service = methods(type);
  return useEitherMutation(({ id, noteId, note, env }) => service.updateNote(id, noteId, note, env), {
    ...options,
  });
};
